import { render, staticRenderFns } from "./VaNumberTable.vue?vue&type=template&id=b60c5d6c"
import script from "./VaNumberTable.vue?vue&type=script&lang=js"
export * from "./VaNumberTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports